export const ENTRY_ATTRIBUTES = {
    PENALTY_IGNORE_REASON: 'actual_clock.penalties.ignore_reason_id',
    PENALTY_STATUS: 'actual_clock.penalties.status',
    BREAK_IN_ACTION_REASON: 'actual_clock.breaks.break_in_action.reason',
    CALL_IN_STATUS: 'actual_clock.call_in.status',
    BREAK_OUT_ACTION_REASON: 'actual_clock.breaks.break_out_action.reason',
    BREAKS_STATUS: 'actual_clock.breaks.status',
    EMPLOYEE_STATUS: 'actual_clock.employee_status',
    EDIT_CARD_REASON: 'edit_card_reason',
    RIGHT_TO_REST: 'actual_clock.right_to_rest',
    RIGHT_TO_REST_STATUS: 'actual_clock.right_to_rest.status',
    RIGHT_TO_REST_DURATION: 'actual_clock.right_to_rest.duration',
    RIGHT_TO_REST_IGNORE_REASON_ID: 'actual_clock.right_to_rest.ignore_reason_id',
    CLOCK_IN: 'actual_clock.clock_in',
    CLOCK_OUT: 'actual_clock.clock_out',
    CLOCK_IN_ACTION_REASON: 'actual_clock.clock_in_action.reason',
    CLOCK_IN_ACTION_SOURCE: 'actual_clock.clock_in_action.source',
    CLOCK_OUT_ACTION_REASON: 'actual_clock.clock_out_action.reason',
    CLOCK_OUT_ACTION_SOURCE: 'actual_clock.clock_out_action.source',
    ACTUAL_CLOCK:'actual_clock',
    CATEGORY: 'actual_clock.category',
    SICK_LEAVE: 'actual_clock.sick_leave',
    ERROR_REASON: 'actual_clock.error_reason.id',
    BREAKS: 'actual_clock.breaks',
    BREAKS_START: 'actual_clock.breaks.start',
    BREAKS_END: 'actual_clock.breaks.end',
    BREAKS_TYPE: 'actual_clock.breaks.type',
    BREAKS_STATUS: 'actual_clock.breaks.status',
    BREAKS_IGNORE_REASON_ID: 'actual_clock.breaks.ignore_reason_id',
    BREAKS_STATUS_REASON: 'actual_clock.breaks.status_reason',
    BREAKS_DURATION: 'actual_clock.breaks.duration',
    JOB_TITLES: 'actual_clock.job_titles',
}

export const RIGHT_TO_REST_ATTRIBUTES = [
    ENTRY_ATTRIBUTES.RIGHT_TO_REST,
    ENTRY_ATTRIBUTES.RIGHT_TO_REST_STATUS,
    ENTRY_ATTRIBUTES.RIGHT_TO_REST_DURATION,
    ENTRY_ATTRIBUTES.RIGHT_TO_REST_IGNORE_REASON_ID
];

export const ENTRY_SOURCES = {
    TEAMHUB: 'TEAMHUB',
    PUNCH: 'PUNCH',
    SYSTEM: 'SYSTEM'
}

export const ACTOR_TYPES = {
    EMPLOYER: 'EMPLOYER',
    EMPLOYEE: 'EMPLOYEE',
    SYSTEM: 'SYSTEM'
}

export const ENTRY_TYPES = {
    OFFLINE_SYNC: 'OFFLINE-SYNC',
    OFFLINE_CONFLICT_RESOLVER: 'OFFLINE-CONFLICT-RESOLVER'
}

export const ENTRY_STATUSES = {
    SYSTEM_APPROVED: 'SYSTEM_APPROVED',
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    APPROVED: 'APPROVED',
    IGNORED: 'IGNORED',
    CONSUMED: 'CONSUMED',
}

export const ENTRY_ACTIONS = {
    ADD: 'ADD',
    REMOVED_FROM_ALLOWED: 'REMOVED_FROM_ALLOWED',
    ADDED_TO_ADDITIONAL: 'ADDED_TO_ADDITIONAL',
    BREAK_TYPE_CHANGED: 'BREAK_TYPE_CHANGED',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    SET: 'SET'
}